import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useNavigationStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
  }),
);
